import * as React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { usePermissions, Permission } from '@/hooks/use-permissions';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

type SelectRootProps = React.ComponentProps<typeof Select>;

interface PermissionSelectProps extends SelectRootProps {
  permission: Permission | Permission[];
  fallbackText?: string;
  children: React.ReactNode;
}

export function PermissionSelect({ 
  permission, 
  fallbackText, 
  children,
  disabled,
  ...props 
}: PermissionSelectProps) {
  const { hasPermission, hasAnyPermission } = usePermissions();
  
  const hasRequiredPermission = Array.isArray(permission) 
    ? hasAnyPermission(permission)
    : hasPermission(permission);
  
  const isDisabled = disabled || !hasRequiredPermission;
  
  if (!hasRequiredPermission && fallbackText) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div>
              <Select {...props} disabled={true}>
                {children}
              </Select>
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p>{fallbackText}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
  
  return (
    <Select {...props} disabled={isDisabled}>
      {children}
    </Select>
  );
}
